import { LabelState } from 'src/types/redux';
import {
  FETCH_LABEL_FAILURE,
  FETCH_LABEL_REQUEST,
  FETCH_LABEL_SUCCESS,
  LabelActionType,
} from '../types/labelType';

const initialState = {
  loading: false,
  labelData: [],
  error: '',
};
export const itemLabelReducer = (
  state = initialState,
  action: LabelActionType
) => {
  switch (action.type) {
    case FETCH_LABEL_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case FETCH_LABEL_SUCCESS:
      return {
        ...state,
        loading: false,
        labelData: action.payload,
      };
    case FETCH_LABEL_FAILURE:
      return {
        ...state,
        laoding: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
